import { Button } from 'foundations-components/transitional/components/Button';
import { useMediaQuery } from '../../lib/useBreakpoint';
import { jsxs as _jsxs } from "react/jsx-runtime";
export const ActionButton = ({
  disabled,
  onClick,
  icon,
  text,
  'data-test-id': dataTestId
}) => {
  // Only show the text on large screens
  const isLargeScreen = useMediaQuery('(min-width: 1212px)');
  return /*#__PURE__*/_jsxs(Button, {
    disabled: disabled,
    marginInlineStart: "0",
    onClick: onClick,
    use: "tertiary-light",
    paddingBlock: "25",
    size: "xs",
    "data-test-id": dataTestId,
    children: [icon, isLargeScreen && text]
  });
};
ActionButton.displayName = 'ActionButton';